/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject, signal } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'chat-bot-info',
  standalone: true,
  imports: [ CommonModule, TranslateModule ],
  templateUrl: './chatBotInfo.component.html',
  styleUrl: './chatBotInfo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatBotInfoComponent {
    private modalController = inject(ModalController);

    closeModal(){
        this.modalController.dismiss().catch(e => {
            console.warn("No modal found on dismiss")
        });
    }
 }
